export function createPursuitField({ name, opportunityName, pursuitName, fieldType = 'string', requiredId }) {
  const field = {
    name,
    opportunityName,
    pursuitName,
    newValue: {
      id: null,
      text: '',
    },
    incomingValue: {
      id: null,
      text: '',
    },
    overwrite: false,
    fieldType,
  };

  if (requiredId) {
    field.requiredId = requiredId;
  }

  return field;
}

export const STATE_LOCAL_PURSUIT_FIELDS = [
  createPursuitField({ name: 'Name', opportunityName: 'title', pursuitName: 'pursuitName' }),
  createPursuitField({
    name: 'Due Date',
    opportunityName: 'proposalDeadline',
    pursuitName: 'dueDate',
    fieldType: 'date',
  }),
];

export const STATE_LOCAL_AWARD_PURSUIT_FIELDS = [
  createPursuitField({ name: 'Name', opportunityName: 'title', pursuitName: 'pursuitName' }),
  createPursuitField({ name: 'Agency', opportunityName: 'agencyName', pursuitName: 'agencyName' }),
  createPursuitField({
    name: 'Award Date',
    opportunityName: 'registrationDate',
    pursuitName: 'dueDate',
    fieldType: 'date',
  }),
];
